import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ActionType } from "./actions.js";
import { addTableAction, changeTableColorAction, changeTableCommentAction, changeTableGroupAction, changeTableLogicalNameAction, changeTableNameAction, changeTableNameDerivedAction, moveTableAction, moveToTableAction, removeTableAction } from "./atom.actions.js";
import { groupBy, head, isString, last, pick } from "es-toolkit";
//#region src/engine/modules/table/history.ts
var MOVE_MIN = 20;
var addTable = (undoActions, { payload: { id } }) => {
	undoActions.push(removeTableAction({ id }));
};
var removeTable = (undoActions, { payload: { id } }, { collections }) => {
	const table = query(collections).collection("tableEntities").selectById(id);
	if (!table) return;
	undoActions.push(addTableAction({
		id: table.id,
		ui: pick(table.ui, [
			"x",
			"y",
			"zIndex"
		])
	}));
};
var changeTableName = (undoActions, { payload: { id } }, { collections }) => {
	const table = query(collections).collection("tableEntities").selectById(id);
	if (!table) return;
	undoActions.push(changeTableNameAction({
		id,
		value: table.name
	}));
};
var changeTableLogicalName = (undoActions, { payload: { id } }, { collections }) => {
	const table = query(collections).collection("tableEntities").selectById(id);
	if (!table) return;
	undoActions.push(changeTableLogicalNameAction({
		id,
		value: table.logicalName
	}));
};
var changeTableNameDerived = (undoActions, { payload: { id } }, { collections }) => {
	const table = query(collections).collection("tableEntities").selectById(id);
	if (!table) return;
	undoActions.push(changeTableNameDerivedAction({
		id,
		value: table.nameDerived
	}));
};
var changeTableComment = (undoActions, { payload: { id } }, { collections }) => {
	const table = query(collections).collection("tableEntities").selectById(id);
	if (!table) return;
	undoActions.push(changeTableCommentAction({
		id,
		value: table.comment
	}));
};
var changeTableGroup = (undoActions, { payload: { id, prevValue } }, { collections }) => {
	const table = query(collections).collection("tableEntities").selectById(id);
	if (!table) return;
	undoActions.push(changeTableGroupAction({
		id,
		value: isString(prevValue) ? prevValue : table.groupId
	}));
};
var moveToTable = (undoActions, { payload: { id } }, { collections }) => {
	const table = query(collections).collection("tableEntities").selectById(id);
	if (!table) return;
	undoActions.push(moveToTableAction({
		id,
		x: table.ui.x,
		y: table.ui.y
	}));
};
var sortTable = () => {};
var tablePushUndoHistoryMap = {
	[ActionType.addTable]: addTable,
	[ActionType.removeTable]: removeTable,
	[ActionType.changeTableName]: changeTableName,
	[ActionType.changeTableComment]: changeTableComment,
	[ActionType.changeTableGroup]: changeTableGroup,
	[ActionType.moveToTable]: moveToTable,
	[ActionType.sortTable]: sortTable,
	[ActionType.changeTableLogicalName]: changeTableLogicalName,
	[ActionType.changeTableNameDerived]: changeTableNameDerived
};
var moveTable = (undoActions, redoActions, actions) => {
	const moveTableActions = actions.filter((action) => action.type === moveTableAction.type);
	if (!moveTableActions.length) return;
	const group = groupBy(moveTableActions, (action) => action.payload.ids.join(","));
	for (const [, actions] of Object.entries(group)) {
		const { payload: { ids } } = head(actions);
		const { x, y } = actions.reduce((acc, { payload: { movementX, movementY } }) => {
			acc.x += movementX;
			acc.y += movementY;
			return acc;
		}, {
			x: 0,
			y: 0
		});
		if (Math.abs(x) + Math.abs(y) < MOVE_MIN) continue;
		undoActions.push(moveTableAction({
			ids,
			movementX: -1 * x,
			movementY: -1 * y
		}));
		redoActions.push(moveTableAction({
			ids,
			movementX: x,
			movementY: y
		}));
	}
};
var changeTableColor = (undoActions, redoActions, actions) => {
	const changeTableColorActions = actions.filter(({ type }) => type === changeTableColorAction.type);
	if (!changeTableColorActions.length) return;
	const group = groupBy(changeTableColorActions, (action) => action.payload.id);
	for (const [id, actions] of Object.entries(group)) {
		const firstAction = head(actions);
		const lastAction = last(actions);
		undoActions.push(changeTableColorAction({
			id,
			color: firstAction.payload.prevColor,
			prevColor: lastAction.payload.color
		}));
		redoActions.push(changeTableColorAction({
			id,
			color: lastAction.payload.color,
			prevColor: firstAction.payload.prevColor
		}));
	}
};
var tablePushStreamHistoryMap = {
	[ActionType.moveTable]: moveTable,
	[ActionType.changeTableColor]: changeTableColor
};
//#endregion
export { tablePushStreamHistoryMap, tablePushUndoHistoryMap };
